// extracted by mini-css-extract-plugin
export default {"border":"Assets_border__QyC4K"};